export default __webpack_public_path__ + "static/media/commission-calculator.add8697c.png";